import { STORAGE_KEYS } from "../Constants/storageKeys";

/**
 * Cross-flow `localStorage` markers set early (at a "Continue"/"Pay" click)
 * by the change-date, upgrade-to-premium, add-shuttle, and manage-seating
 * flows. Each is read on the payment-gateway callback
 * (`PaymentGatewayCheckoutAction`) to fire a flow-specific success toast or to
 * rehydrate flow state after a refresh.
 *
 * Because they are set BEFORE payment but only cleared on the flow's own happy
 * path, an abandoned flow leaves one set. The next, unrelated payment then
 * inherits it — e.g. a normal booking showing "Your booking has been updated"
 * because a stale `isChangeDateFlowForToast` survived an abandoned change-date
 * attempt.
 */
const OTHER_FLOW_FLAGS = [
  STORAGE_KEYS.CHANGE_DATE_FLOW, // "isChangeDateFlow"
  "isChangeDateFlowForToast",
  "isUpgradeToPremiumFlow",
  "isAddShuttleTransferFlow",
  "isManageSeatingFlow",
] as const;

/**
 * Wipe the competitor flow markers above.
 *
 * Called from TWO places, and the second is the load-bearing one:
 *
 *  - Payment.tsx, when a different flow commits to payment, so a stale marker
 *    cannot fire a wrong toast on the new payment. This was the original case.
 *  - GetSearchResultAction, on a fresh search — i.e. at the START of a new
 *    booking, alongside the flow ATOMS clearBookingFlowAtoms resets there.
 *
 * A wrong toast is NOT the worst of it, which is why Pay-click alone was not
 * enough. PrepareBookingSummaryAction gates its whole normal-checkout branch on
 * CHANGE_DATE_FLOW, so a flag left "true" by an abandoned change-date made every
 * later booking run the summary action and rebuild NOTHING —
 * checkoutPaymentSummaryAtom kept its previous contents, and a shuttle added on
 * that booking was charged for but never drawn or totalled. Reported from INT
 * 2026-08-26; see freshSearchClearsFlowFlags.test.ts.
 */
export function clearOtherFlowFlags(): void {
  if (typeof window === "undefined") return;
  OTHER_FLOW_FLAGS.forEach((key) => localStorage.removeItem(key));
}
